import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { target: String }

  dismiss() {
    this.element.remove()
  }

  confirm() {
    const form = document.querySelector(this.targetValue)
    if (form) {
      const hiddenField = document.createElement("input")
      hiddenField.type = "hidden"
      hiddenField.name = "skip_delivery_specification_validation"
      hiddenField.value = "true"
      form.appendChild(hiddenField)
      form.requestSubmit()
    }
    this.element.remove()
  }
}
